export const STATUS_COLORS = {
    active: '#1E8E3E',
    passive: '#E8730C',
    closed: '#D32F2F',
    unknown: '#9AA5B1',
};

export const EMPTY_VALUE = '—';

export function normalizeStatus(raw) {
    if (!raw) return 'unknown';
    const lower = String(raw).trim().toLowerCase();

    if (lower === 'regjistruar' || lower === 'aktiv' || lower === 'registered' || lower === 'active' || lower === 'registrovan' || lower === 'aktivan') return 'active';
    if (lower.startsWith('pasiv') || lower.startsWith('passive')) return 'passive';
    if (
        lower.startsWith('shuar')
        || lower.startsWith('çregjistruar')
        || lower.startsWith('cregjistruar')
        || lower.includes('shuar/çregjistruar')
        || lower.startsWith('deregistered')
        || lower.startsWith('closed')
        || lower.startsWith('ugašen')
        || lower.startsWith('odjavljen')
    ) {
        return 'closed';
    }
    return 'unknown';
}

const STATUS_LABELS = {
    sq: { active: 'Aktiv', passive: 'Pasiv', closed: 'Shuar' },
    en: { active: 'Active', passive: 'Passive', closed: 'Closed' },
    sr: { active: 'Aktivan', passive: 'Pasivan', closed: 'Ugašen' },
};

export function statusMeta(key, locale = 'sq') {
    const labels = STATUS_LABELS[locale] || STATUS_LABELS.sq;
    return {
        key,
        color: STATUS_COLORS[key],
        label: key === 'unknown' ? EMPTY_VALUE : labels[key],
        muted: key === 'passive' || key === 'closed',
    };
}

export function displayOrDash(v) {
    return v && String(v).trim() ? String(v).trim() : EMPTY_VALUE;
}
